"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Paragraph = require("../Paragraph");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LoadMoreWrapper = _styledComponents.default.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 30px 0;
	text-align: center;

	button {
		margin-bottom: 10px;
	}
`;

const LoadMoreButton = ({
  onClick,
  total,
  count,
  textToDisplay,
  maxRows
}) => {
  if (count >= maxRows) {
    return /*#__PURE__*/_react.default.createElement(LoadMoreWrapper, null, /*#__PURE__*/_react.default.createElement(_Paragraph.Detail3, null, "Maximum allowable row limit of ", maxRows.toLocaleString(), ' ', "reached."), /*#__PURE__*/_react.default.createElement(_Paragraph.Detail2, null, "Please use the filter options if you need to refine further."));
  }

  return /*#__PURE__*/_react.default.createElement(LoadMoreWrapper, null, count >= total ? /*#__PURE__*/_react.default.createElement(_Paragraph.Detail3, null, textToDisplay) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: onClick,
    variant: "outlined"
  }, "Load More"), /*#__PURE__*/_react.default.createElement(_Paragraph.Detail2, null, "Records will be loaded in blocks of 50,", /*#__PURE__*/_react.default.createElement("br", null), "up to a maximum of ", maxRows.toLocaleString(), " rows")));
};

LoadMoreButton.propTypes = {
  total: _propTypes.default.number,
  count: _propTypes.default.number,
  onClick: _propTypes.default.func,
  textToDisplay: _propTypes.default.string,
  maxRows: _propTypes.default.number
};
LoadMoreButton.defaultProps = {
  total: 0,
  count: 0,
  onClick: () => {},
  textToDisplay: 'All records have been loaded',
  maxRows: 1000
};
var _default = LoadMoreButton;
exports.default = _default;